// Generated by Elm for startup, publishing, and the native font loader.
import plans from './font-policy.json' with {type:'json'};
export const readingProfiles=plans.profiles;
function profileKey(language='en'){
  try{
    const locale=new Intl.Locale(language),script=locale.script||locale.maximize().script;
    const keys=[`${script}|${locale.language}|${locale.region||''}`,`${script}|${locale.language}`,`${script}||${locale.region||''}`,script];
    return keys.map(key=>plans.rules[key]).find(Boolean)||'system';
  }catch{return 'system';}
}
export const dyslexiaProfile=(language='en')=>readingProfiles[profileKey(language)];
export const readingStylesheets=profile=>profile.stylesheets;
export function readingTypography(family,language='en'){
  return (plans.families[family==='readex'?'dyslexic':family]||plans.families.system)[profileKey(language)];
}
